module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_50000_75000.5ebccba5.png";